<div *ngIf="done">
    <div class="alert alert-success">
        Dit kodeord er blevet nulstillet!<br>
        <a [routerLink]="['/login']">Log ind her</a>
    </div>
</div>
<div  class="loginForm" *ngIf="!done">
    <form [formGroup]="resetPassFormGroup">
        <h2 class="text-center">Nulstil kodeord</h2>
        <div *ngIf="wrongInput" class="alert alert-danger">
            {{wrongInputReason}}
        </div>
        <div class="form-group">
            <input type="password" class="form-control input-lg" placeholder="Nyt kodeord" formControlName="password">
        </div>
        
        <div class="form-group">
            <input type="password" class="form-control input-lg" placeholder="...bekræft nyt kodeord" formControlName="confirmPassword">
        </div>

        <!--<div class="form-group">
            <input class="form-control input-lg" type="password" placeholder="Kodeord" formControlName="password">
        </div>-->
        <div class="form-group">
            <button type="submit" class="btn btn-primary btn-lg btn-block"  (click)="onSubmit()">Nulstil kodeord</button>
        </div>
    </form>
</div>